import { render } from "./RoomStatus.vue?vue&type=template&id=00f55c70&scoped=true"
import script from "./RoomStatus.vue?vue&type=script&lang=js"
export * from "./RoomStatus.vue?vue&type=script&lang=js"

import "./RoomStatus.vue?vue&type=style&index=0&id=00f55c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f55c70"]])

export default __exports__